<template>
  <div class="form-view">
    <editor ref="editor" v-model="ruleForm.introduction" @input="getHtml" height="500"></editor>
    <div class="footer">
      <el-button type="primary" class="submit" @click="submit()">提交</el-button>
    </div>
  </div>
</template>

<script>
import companyApi from '@/api/company'
import editor from '@/components/myEdit'
export default {
  name: 'addIntraduce',
  props: ['rowId'],
  components: {
    editor
  },
  data () {
    return {
      formLabelWidth: '150px',
      ruleForm: {
        introduction: '213123'
      }
    }
  },
  methods: {
    getHtml (e) {
      this.ruleForm.introduction = e
    },
    submit () {
      if (this.ruleForm.introduction.length > 0) {
        companyApi.updateForMajor(this.ruleForm).then(res => {
          this.$message.success('操作成功!')
          this.$emit('action')
        })
      } else {
        this.$message.warning('请输入简介!')
      }
    }
  },
  mounted () {
    if (this.rowId) {
      companyApi.queryDetailForMajorByRowId({
        rowId: this.rowId
      }).then(res => {
        this.ruleForm = res
      })
    } 
  }
}
</script>

<style scoped lang="less">
.form-view{
  overflow: auto;
}
</style>
